var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgUserRemove = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 17 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.833 5.333a2.665 2.665 0 0 0-2.666-2.666 2.665 2.665 0 1 0 0 5.333 2.665 2.665 0 0 0 2.666-2.667zm2 1.334V8h4V6.667h-4zM1.833 12v1.333H12.5V12c0-1.773-3.553-2.667-5.333-2.667-1.78 0-5.334.894-5.334 2.667z"
})));
export default SvgUserRemove;